<p-toast></p-toast>


<p-card styleClass="p-card-shadow" >
    <div class="dashboardTable">
        
        <p-table #miSurvey  [value]="tankAbstract"  dataKey="AppId_ProgID"
        [rows]="10"
        [paginator]="true" [globalFilterFields]="[
        'AppID',
		'Program_Name',
		'ChallanType',
		'farmerName',
		'District',
		'Block',
		'Village',
        'Applicant_type',
		'VendorAcknowledgmentStatus',
		'BankAcknowledgementStatus',
        'ChallanAmount',
        'Deposit_Amount',
        'UTR',
        'FromAccountNumber',
        'FromBankName',
        'PaymentAcknowledgedByBankOn',
        'ReferenceID',
        'RemitterName',
        'TransferMode',

        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true"
        (onFilter)="tableDataFunction($event)"
        (onPage)="onPage($event)" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{'CHALLAN_REPORT'| translate}}</h5>
                <span>
                    <button  (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT' | translate}}" icon="pi pi-upload"
                    class="p-button-help"></button>
               
                <p-menu #menu [popup]="true" [model]="appVerificationItems" ></p-menu>
                </span>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                        (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                             
                <th pFrozenColumn pSortableColumn="AppID">{{'APP_ID'| translate}}
                    <p-columnFilter type="text" field="AppID" display="menu"></p-columnFilter>
                    <p-sortIcon field="AppID"></p-sortIcon>
                </th>
                <th pSortableColumn="Program_Name">{{'PROGRAM_NAME'| translate}}
                    <p-columnFilter type="text" field="Program_Name" display="menu"></p-columnFilter>
                    <p-sortIcon field="Program_Name"></p-sortIcon>
                </th>
                <th pSortableColumn="ChallanType">{{'CHALLAN_TYPE'| translate}}
                    <p-columnFilter type="text" field="ChallanType" display="menu"></p-columnFilter>
                    <p-sortIcon field="ChallanType"></p-sortIcon>
                </th>
                <th pSortableColumn="ChallanAmount">{{'CHALLAN_AMOUNT'| translate}}
                    <p-columnFilter type="text" field="ChallanAmount" display="menu"></p-columnFilter>
                    <p-sortIcon field="ChallanAmount"></p-sortIcon>
                </th>
                <th pSortableColumn="Deposit_Amount">{{'DEPOSIT_AMOUNT'| translate}}
                    <p-columnFilter type="text" field="Deposit_Amount" display="menu"></p-columnFilter>
                    <p-sortIcon field="Deposit_Amount"></p-sortIcon>
                </th>
                <th pSortableColumn="UTR">{{'UTR'| translate}}
                    <p-columnFilter type="text" field="UTR" display="menu"></p-columnFilter>
                    <p-sortIcon field="UTR"></p-sortIcon>
                </th>
                <th pSortableColumn="FromAccountNumber">{{'ACCOUNT_NUMBER'| translate}}
                    <p-columnFilter type="text" field="FromAccountNumber" display="menu"></p-columnFilter>
                    <p-sortIcon field="FromAccountNumber"></p-sortIcon>
                </th>
                <th pSortableColumn="FromBankName">{{'BANK_NAME'| translate}}
                    <p-columnFilter type="text" field="FromBankName" display="menu"></p-columnFilter>
                    <p-sortIcon field="FromBankName"></p-sortIcon>
                </th>
                <th pSortableColumn="PaymentAcknowledgedByBankOn">{{'PAYMENT_DATE'| translate}}
                    <p-columnFilter type="text" field="PaymentAcknowledgedByBankOn" display="menu"></p-columnFilter>
                    <p-sortIcon field="PaymentAcknowledgedByBankOn"></p-sortIcon>
                </th>
                <th pSortableColumn="ReferenceID">{{'REFERNCE_ID'| translate}}
                    <p-columnFilter type="text" field="ReferenceID" display="menu"></p-columnFilter>
                    <p-sortIcon field="ReferenceID"></p-sortIcon>
                </th>
                <th pSortableColumn="RemitterName">{{'REMITTER_NAME'| translate}}
                    <p-columnFilter type="text" field="RemitterName" display="menu"></p-columnFilter>
                    <p-sortIcon field="RemitterName"></p-sortIcon>
                </th>
                <th pSortableColumn="TransferMode">{{'TRANSFER_MODE'| translate}}
                    <p-columnFilter type="text" field="TransferMode" display="menu"></p-columnFilter>
                    <p-sortIcon field="TransferMode"></p-sortIcon>
                </th>
                <th pSortableColumn="farmerName">{{'FARMER_NAME'| translate}}
                    <p-columnFilter type="text" field="farmerName" display="menu"></p-columnFilter>
                    <p-sortIcon field="farmerName"></p-sortIcon>
                </th>
                <th pSortableColumn="District">{{'DISTRICT'| translate}}
                    <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                    <p-sortIcon field="District"></p-sortIcon>
                </th>
                <th pSortableColumn="Block">{{'BLOCK'| translate}}
                    <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                    <p-sortIcon field="Block"></p-sortIcon>
                </th>
                <th pSortableColumn="Village">{{'VILLAGE'| translate}}
                    <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                    <p-sortIcon field="Village"></p-sortIcon>
                </th>
                <th pSortableColumn="Applicant_type">{{'APPLICATION_TYPE'| translate}}
                    <p-columnFilter type="text" field="Applicant_type" display="menu"></p-columnFilter>
                    <p-sortIcon field="Applicant_type"></p-sortIcon>
                </th>
                <th pSortableColumn="VendorAcknowledgmentStatus">{{'VENDOR_ACKNOWLEDGMENT_STATUS'| translate}}
                    <p-columnFilter type="text" field="VendorAcknowledgmentStatus" display="menu"></p-columnFilter>
                    <p-sortIcon field="VendorAcknowledgmentStatus"></p-sortIcon>
                </th>
                <th pSortableColumn="BankAcknowledgementStatus">{{'BANK_ACKNOWLEDGMENT_STATUS'| translate}}
                    <p-columnFilter type="text" field="BankAcknowledgementStatus" display="menu"></p-columnFilter>
                    <p-sortIcon field="BankAcknowledgementStatus"></p-sortIcon>
                </th>
            
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-tankAbstract>
            <tr>
                <td pFrozenColumn>{{tankAbstract.AppID}}</td>
                <td>{{tankAbstract.Program_Name}}</td>
                <td>{{tankAbstract.ChallanType}}</td>
                <td>{{tankAbstract.ChallanAmount}}</td>
                <td>{{tankAbstract.Deposit_Amount}}</td>
                <td>{{tankAbstract.UTR}}</td>
                <td>{{tankAbstract.FromAccountNumber}}</td>
                <td>{{tankAbstract.FromBankName}}</td>
                <td>{{tankAbstract.PaymentAcknowledgedByBankOn | date:'mediumDate'}}</td>
                <td>{{tankAbstract.ReferenceID}}</td>
                <td>{{tankAbstract.RemitterName}}</td>
                <td>{{tankAbstract.TransferMode}}</td>
                <td>{{tankAbstract.farmerName}}</td>
                <td>{{tankAbstract.District}}</td>
                <td>{{tankAbstract.Block}}</td>
                <td>{{tankAbstract.Village}}</td>
                <td>{{tankAbstract.Applicant_type}}</td>
                <td>{{tankAbstract.VendorAcknowledgmentStatus}}</td>
                <td>{{tankAbstract.BankAcknowledgementStatus}}</td>
                
            </tr>
        </ng-template>
        <!-- <ng-template pTemplate="footer">
            <tr>
                <td >  Total</td>
                <td >{{tankApp | number:'1.0-2'}}</td>
                <td >{{tankCoverageArea | number:'1.0-2'}}</td>
                <td >{{tankVerifiedApp | number:'1.0-2'}}</td>
                <td >{{tankRpApp | number:'1.0-2'}}</td>
                <td >{{tankRejectedApp | number:'1.0-2'}}</td>
                <td >{{tankVerifiedCoverageApp | number:'1.0-2'}}</td>
            </tr>
            <tr>
                <td > Grand Total</td>
                <td >{{grandTankApp | number:'1.0-2'}}</td>
                <td >{{grandTankCoverageArea | number:'1.0-2'}}</td>
                <td >{{grandTankVerifiedApp | number:'1.0-2'}}</td>
                <td >{{grandTankRpApp | number:'1.0-2'}}</td>
                <td >{{grandTankRejectedApp | number:'1.0-2'}}</td>
                <td >{{grandTankVerifiedCoverageApp | number:'1.0-2'}}</td>
            </tr>
        </ng-template> -->
    
        </p-table>
    </div>
    </p-card>